// FILE: src/firebase.js
// Centralized Firebase init for CRA. Exports app + SDKs.
// Uses REACT_APP_* variables from .env.
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { setLogLevel } from "firebase/firestore";
if (process.env.NODE_ENV !== "production") setLogLevel("debug");


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Single app instance (avoid duplicate init in hot-reload)
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// SDKs
const auth = getAuth(app);

const provider = new GoogleAuthProvider();
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, process.env.REACT_APP_FUNCTION_REGION || "us-central1");


// Helpful for manual debugging (development-only to avoid leaking auth objects in production)
if (typeof window !== "undefined" && process.env.NODE_ENV !== "production") {
  window.__FW = { app, auth, db, storage, functions };
  window.auth = auth;
  try {
    const pid = app?.options?.projectId;
     if (pid) {
      // eslint-disable-next-line no-console
      console.info(`[firebase] projectId: ${pid}`);
    }
  } catch {}
}

export { app, auth, provider, db, storage, functions };
